<template>
  <div  class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="close()"><i class="icon-close"></i></a>
          <h3 class="modal-title">要保人{{nameBir}}未拜訪原因</h3>
        </div>
            <div class="modal-body send-modal-body" style="min-height:220px;">
            <div class="form-group mt-3">
                <div class="radio radio-inline">
                    <input type="radio" v-model="req.picked" name="radio-type-1" id="radio-type-1" value="8">
                    <label for="radio-type-1">電話地址不正確</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="req.picked" name="radio-type-2" id="radio-type-2" value="9">
                    <label for="radio-type-2">保戶移居海外</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="req.picked" name="radio-type-3" id="radio-type-3" value="2">
                    <label for="radio-type-3">無法遇人</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="req.picked" name="radio-type-4" id="radio-type-4" value="3">
                    <label for="radio-type-4">保戶拒訪</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="req.picked" name="radio-type-5" id="radio-type-5" value="6">
                    <label for="radio-type-5">身故</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="req.picked" name="radio-type-6" id="radio-type-6" value="7">
                    <label for="radio-type-6">轉籍</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="req.picked" name="radio-type-7" id="radio-type-7" value="4">
                    <label for="radio-type-7">其他</label>
                </div>
                <div>
                    <input v-if="req.picked == 4" type="text"  id="reason" name="reason" maxlength="10" placeholder="請輸入原因" class="form-control" v-model="req.reason"/>
                    <input v-else  type="text"  id="reason" name="reason" maxlength="10" placeholder="請輸入原因" class="form-control" v-model="req.reason" :disabled="true"/>
                </div>
                <br>
                <div class="font-weight-bold">該保戶尚有其他未到期之滿期保單如下，請選取是否一起更新為拜訪說明。</div>
                <table class="table datatable table-striped area-list-datatable">
                  <thead>
                      <tr>
                          <th width="*">
                            <div class="checkbox checkbox-inline mr-0">
                                <input 
                                @click="clickTarget1 = clickTarget1 == `clickAll`? `clickAll-again`: `clickAll`"
                                type="checkbox" 
                                name="dtData" 
                                id="dtData" 
                                value="1" 
                                v-model="checkAll">
                                <label for="dtData"></label>
                            </div>
                              全選</th>
                          <th width="*">滿期保單號碼</th>
                          <th width="*">滿期日</th>
                          <th width="*">滿期金額</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(item,i) in dtData" :key="`dtData-${i}`">
                          <td width="*">
                            <div style="min-height: 30px;">
                              <div class="mr-0 checkbox checkbox-inline">
                                <input
                                @click="clickTarget1 = clickTarget1 == `td-${i}`? `td-${i}-again`: `td-${i}`"
                                :value="item.plcno"
                                :id="`dtData-${i}`"
                                type="checkbox"
                                v-model="selection"
                               >
                                <label :for="`dtData-${i}`"></label>
                              </div>
                            </div>
                          </td>
                          <td width="*">{{item.plcno}}</td>
                          <td width="*">{{item.lpsdt| dateFormat}}</td>
                          <td width="*">{{item.lpsamt| numberFormat}}</td>
                      </tr>    
                  </tbody>
              </table>
            </div>
            <div class="action text-right">
              <a @click.stop.prevent="close()" class="btn btn-primary">
                關閉
              </a>
              <a @click.stop.prevent="submit()" class="btn btn-primary">
                回報
              </a>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import DatePicker from '@/components/DatePicker/components/Datepicker'
import {en, zh} from '@/components/DatePicker/locale'
import {  getCustInfo, getCustFullInfo, updateNonVisitReason  } from '@/service'

export default {
  name: 'NonVisitReason',
  mixins: [commonMixin],
  components: { DatePicker },
  props: {
    record: {  // 客戶list 資料
      type: Object,
      default: () => {
        return null;
      }
    },
    open: {
      type: Boolean,
      default: false
    },
    catInfo: {  // 專區資訊
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data () {
    return {
      clickTarget1: '',
      dtData: [],
      selection: [],
      checkAll: false,
      nameBir: '',
      selectOpt: [],
      req: {
        reason: "",
        picked: ""
      },
      dateFormatter: (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      edit: false
    }
  },
  watch: {
    open (val) { 
      if(val) {
        this.Init();
      }
    },
    "req.reason": function() {
      this.req.reason = this.cleanSpecialChar(this.req.reason, '~()!');
    },
    clickTarget1: function(target){
        if(target == 'clickAll' || target == 'clickAll-again') {  //點了全選checkbox
          if(this.checkAll) {  //點了全選
            this.selection = [];
            this.dtData.forEach(data => {
              this.selection.push(data.plcno);
            });
          } else {  //取消全選
            this.selection = [];
          }
        } else {  //點了其他checkbox
          this.checkAll = this.selection.length == this.dtData.length;
        }
      },
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    Init () {  // 初始化
      this.getcustNm(); // 取得要保人名稱
      this.getInfo(); // 產生滿期保單資訊
 
    },
    getInfo () { // 產生滿期保單資訊
        getCustFullInfo(this.$store.state.userInfo.id, this.record.id).then(result => {
        if(result.header && result.header.status == '200'){
          this.dtData = result.body.lists;
          this.selection.push(this.record.policy_no);
        }
        this.registerHanlink()  // for 難字更新
      })
    },
    getcustNm () { // 取得要保人名稱
      getCustInfo(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.record.id).then(result => {
        if(result.header && result.header.status == '200'){
          let customer = result.body.customer;
          this.nameBir =  this.record.name;
        }
        this.registerHanlink();  // for 難字更新
      })

    },
    submit() {
      let reportData ={
        getplcno: this.selection,
        reason: this.req.picked,
        reasonmemo: this.req.reason
      }
      updateNonVisitReason(this.$store.state.userInfo.id, reportData).then(result => {
        if(result.header && result.header.status == '200'){
          this.req.reason = "";
          this.req.picked = "";
          this.selection = [];
          this.$emit('close');
        }
      })
    },
    close(){
      this.req.reason = "";
      this.req.picked = "";
      this.selection = [];
      this.$emit('close');
    }
  },
  mounted () {}
}
</script>

<style>
.vdp-datepicker input {
  width: 100px;
  padding: 10px;
}
.select-100 {
  width: 170px;
}
.non-select-arrow  {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}
.btn-grids .btn {
  position: relative;
  padding: 8px;
  width: 24%;
  font-size: 1rem;
  margin: 0px;
  margin-bottom: 10px;
  margin-right: 1%;
}
.btn-grids .add-new{
  padding: 8px;
  width: 50px !important;
  font-size: 16px;
}
.btn-grids .btn .close {
  position: absolute;
  right: -10px;
  top: -10px;
}

</style>